import React, { FC } from 'react';
import { Box, Checkbox, Text } from '@bechtel/gds';
import { FieldArray, FieldProps } from 'formik';
import { findIndex, some, map } from 'lodash';
import { ListSelectionStyled, DrawerSubHeaderStyled, SubListSelectionStyled } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';
import { weldTypes } from '../form-state';
import { useLingui } from '@lingui/react';

export const WeldTypeList: FC<FieldProps> = ({ form }) => {
  const { i18n } = useLingui();

  return (
    <Box flexDirection={{ sm: 'column' }} data-testid="weld-type-container">
      <DrawerSubHeaderStyled>
        <Trans>Type</Trans>
      </DrawerSubHeaderStyled>
      <SubListSelectionStyled
        data-testid="weld-type-all"
        onClick={() => {
          if (form.values.weldTypes?.length !== weldTypes.length) {
            form.setFieldValue('weldTypes', map(weldTypes, 'value'));
          } else {
            form.setFieldValue('weldTypes', []);
          }
        }}
      >
        <Box alignItems={{ sm: 'center' }}>
          <Box mr={{ sm: '500' }}>
            <Checkbox
              checked={form.values.weldTypes?.length === weldTypes.length}
              indeterminate={form.values.weldTypes?.length > 0 && form.values.weldTypes?.length < weldTypes.length}
              readOnly
            />
          </Box>
          <Text size="400" weight="600" color="bechtel.grey.1000">
            <Trans>Select All</Trans>
          </Text>
        </Box>
        {form.values.weldTypes && form.values.weldTypes.length > 0 && (
          <Text size="400" color="bechtel.grey.1000" data-testid="weld-type-selected-length">
            {form.values.weldTypes.length} <Trans>Selected</Trans>
          </Text>
        )}
      </SubListSelectionStyled>
      <FieldArray name="weldTypes">
        {(arrayHelpers) => {
          return (
            <>
              {weldTypes.length > 0 &&
                weldTypes.map((weldTypeItem) => {
                  return (
                    <ListSelectionStyled
                      key={weldTypeItem.id}
                      data-testid={`weld-type-item-${weldTypeItem.id}`}
                      onClick={() => {
                        const selected = findIndex(form.values.weldTypes, (item) => {
                          return item === weldTypeItem.value;
                        });
                        if (selected !== -1) {
                          arrayHelpers.remove(selected);
                        } else {
                          arrayHelpers.push(weldTypeItem.value);
                        }
                      }}
                    >
                      <Box mr={{ sm: '500' }}>
                        <Checkbox
                          checked={some(form.values.weldTypes, (item) => {
                            return item === weldTypeItem.value;
                          })}
                          readOnly
                        />
                      </Box>
                      <Text size="400" color="bechtel.grey.1000">
                        {i18n._(weldTypeItem.label)}
                      </Text>
                    </ListSelectionStyled>
                  );
                })}
            </>
          );
        }}
      </FieldArray>
    </Box>
  );
};
